var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiskeyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.542 146.571C124.321 149.714 121.708 152.15 118.557 152.15H61.0648C57.9231 152.15 55.3133 149.726 55.0812 146.593L50.4773 84.4432C50.2196 80.9645 52.9726 78 56.4609 78H122.929C126.408 78 129.158 80.9501 128.914 84.421L124.542 146.571Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.784 100.518C127.784 100.518 100.925 95.5288 89.728 100.518C78.5307 105.508 51.6719 100.518 51.6719 100.518",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.532 88.4937L82.741 90.1382C79.4506 90.5306 77.1013 93.516 77.4936 96.8064L79.1381 110.597C79.5305 113.888 82.5159 116.237 85.8063 115.845L99.5973 114.2C102.888 113.808 105.237 110.822 104.845 107.532L103.2 93.7411C102.808 90.4507 99.8224 88.1014 96.532 88.4937Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiskeyIcon);
export default __webpack_public_path__ + "static/media/whiskey-icon.43a5507636ff50b5a8e8a773ab2523cf.svg";
export { ForwardRef as ReactComponent };